import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceArea } from '../models/reference-area';

@Pipe({
  name: 'referenceAreaDataPreprocessing'
})
export class ReferenceAreaDataPreprocessingPipe implements PipeTransform {
  constructor(private translate: TranslateService) {

  }
  transform(referenceAreas: ReferenceArea[], selectedLanguage: string): ReferenceArea[] {
    return referenceAreas && referenceAreas.map(referenceArea => {
      return {
        ...referenceArea,
        typeCode: referenceArea.type,
        type: this.translate.instant(`I18N_REFERENCE_AREAS.${referenceArea.type}`)
      }
    });
  }

}
